import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestService } from '@app/_services/request.service';
import { authorityIds, operations, subAuthorities } from '@app/enums';

@Injectable({ providedIn: 'root' })
export class CustodianApiService {
  constructor(private REQ: RequestService) {}

  getCustodianList(): Observable<any> {
    const qry = {
      params: {},
      user_data: {
        authority: authorityIds.OSMA_CUSTODIAN,
        sub_authority: subAuthorities.CUSTODIAN.LIST,
        operation: operations.LIST,
        data: 'NA',
        format: 'json',
      },
    };
    return this.REQ.get('osma/custodian', { query: JSON.stringify(qry) });
  }
}
